import {MenuItem, Stack, Typography, useTheme} from '@mui/material';
import React from 'react';

import {IconIllustration} from 'presentation/components/IconIllustration';
import Icon from 'presentation/icons';
import {ProfileMenuItemProps} from './types';

export function ProfileMenuItem({
	label,
	onClick,
	iconName,
	dataTestId,
	dataTagId,
	showErrorIcon,
}: ProfileMenuItemProps) {
	const theme = useTheme();
	return (
		<MenuItem
			onClick={onClick}
			data-testid={dataTestId}
			data-tag-id={dataTagId}
			sx={{
				p: 0,
				gap: 1,
			}}>
			<Stack flex={1} direction="row" alignItems="center" justifyContent="space-between">
				<Stack spacing={2} direction="row" alignItems="center">
					<IconIllustration
						customIconName={iconName}
						variant="primary"
						size="small"
						sx={{p: 1}}
					/>
					<Typography variant="body1" fontWeight={600}>
						{label}
					</Typography>
				</Stack>

				<Stack flexDirection="row" alignItems="center" gap={0.5}>
					{showErrorIcon ? (
						<Icon color={theme.palette.error.main} name="error-fill" size={20} />
					) : null}
					<Icon
						color={theme.palette.primary.main}
						name="chevron-right-outlined"
						size={20}
					/>
				</Stack>
			</Stack>
		</MenuItem>
	);
}
